<script>
  import MonthlyView from '../components/firestore/MonthlyView.svelte'
  import RouteLogsTable from '../views/RouteLogsTable.svelte'
</script>

<MonthlyView
  title="月次 走行記録"
  getCollection={db => db.collectionGroup('routeLogs')}
  query={month => ref =>
    ref
      .orderBy('date')
      .orderBy('order')
      .startAt(month)
      .endAt(month + '\uf8ff')}
  key="client"
  let:id
  let:index
  let:filtered
>
  <RouteLogsTable name={`table${index}`} logs={filtered} />
</MonthlyView>
